export default __webpack_public_path__ + "static/media/delete.de73bfb8.svg";